// extracted by mini-css-extract-plugin
export default {"breadcrumb":"omnia_breadcrumb__breadcrumb--l31B"};